import { getString } from '@/modules/common/helpers/resources';

export const MapPlaceholder = new Map<string, string>([
  ['deposits_schedule_at', getString('suitability_input_day_placeholder')],
  ['question_age', getString('suitability_input_age_placeholder')]
]);
